// extracted by mini-css-extract-plugin
module.exports = {"table":"Overview-module__table___3gGM-"};